let l = "";
export function getLinkByHash(list, hash, i = 0) {
	let hashes = hash.split("-");
	if (list) {
		list.forEach((link) => {
			if (hashes[i] == link.hash || hash == link.hash) {
				if (link.sublist) {
					return getLinkByHash(link.sublist, hash, ++i);
				} else {
					l = link;
				}
			}
		});
	}
	return l;
}